module.exports = {
  title: 'Advisa asiakasportaali',
  metaDescription: 'Kirjaudu nähdäksesi hakemuksesi tilanne',
  jsInfo: 'Sinun on aktivoitava JavaScript nähdäksesi tämän sivun. Varmista, että käytät modernia selainta ja JavaScript on käytössä.',
  unSupportedBrowser: 'Valitettavasti emme tue selaintasi. Jotkut sivun ominaisuudet eivät toimi oikein. Varmista, että käytät modernia selainta.',
  titleForm: 'Advisa Form',
};
